import React from "react";
import { View, StyleSheet } from "@react-pdf/renderer";
import OverviewReportsHeader from "./OverviewReportsHeader";
import OverviewTransactHeader from "./OverviewTransactHeader";
import TransactionRow from "./OverviewReportFolder/TransactionRow";
import PaymentRow from "./OverviewReportFolder/PaymentRow";

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 24,
    borderWidth: 1,
    borderColor: "#bff0fd",
  },
  paytableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 24,
    borderWidth: 1,
    borderColor: "#d9d9d9",
  }
});

const OverviewReportsTable = ({ manageData,openingBalance,closingBalance,clientdetails }) => {
  const ascendingReport = manageData.sort((a, b) => a.id - b.id);

  return( 
    <View>
      <View style={styles.tableContainer} >
        <OverviewReportsHeader clientdata={clientdetails} />
        <TransactionRow taskData={ascendingReport} cd={clientdetails} />
      </View>
      <View style={styles.paytableContainer} >
        <OverviewTransactHeader />
        <PaymentRow taskData={ascendingReport} OB={openingBalance} CB={closingBalance} />
      </View>
  </View>
  )
};

export default OverviewReportsTable;